export const updateExistingSlePermission = (shares, shareKey, newValue) =>
    shares.map((share) => (share.key === shareKey ? { ...share, slePermission: newValue.toUpperCase() } : share));

export const removeSleFromShare = (shares, targetKey) => {
    return shares.map((s) => {
        if (s.key !== targetKey) return s;

        return {
            ...s,
            slePermission: "NONE",
            sleShareKey: null
        };
    });
};

export const normalizeToArray = (value) => (Array.isArray(value) ? value : [value]);

export const mapGradingCriteriaShares = (shares = []) =>
    shares.map((gcs) => ({
        key: gcs.key ?? null,
        permission: gcs.permission,
        gradingCriteriaId: gcs.gradingCriteriaId
    }));

export const syncUpdatedProfile = (updatedProfile, dispatch, state) => {
    dispatch({ type: "SET_SELECTED_EPR", payload: updatedProfile });
    dispatch({
        type: "SET_PROFILES",
        payload: state.gradingProfiles.map((profile) => (profile.key === updatedProfile.key ? updatedProfile : profile))
    });
};

export const shouldDeleteExistingSleShareOnly = (share) => {
    const hasNoCriteria = !Array.isArray(share.gradingCriteriaShares) || share.gradingCriteriaShares.length === 0;

    const hasSleShareKey = !!share.sleShareKey;
    const slePerm = (share.slePermission || "").toUpperCase();

    return hasNoCriteria && hasSleShareKey && slePerm === "NONE";
};
